import { Navigate, Route, Routes } from "react-router-dom";
import { SuccessPage } from "../pages/SuccessPage";
import { StartPage } from "../pages/StartPage";
import { startPath, successPath } from "../utils/urls";

export function RoutingPage() {
	return <Routes>
		<Route path={startPath} element={<StartPage />} />
		<Route path={successPath} element={<SuccessPage />} />
		<Route path={"*"} element={<Navigate to={startPath} />} />
	</Routes>;
}
